import { useEffect, useState } from "react";
import { Contact } from "@/models/chat.model.ts";
import { ChatService } from "@/services/chat.service.ts";
import { useAppSelector } from "@/lib/store.ts";

export function useContacts() {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAppSelector((state) => state.auth);

  const fetchContacts = async () => {
    // Only fetch contacts if user is authenticated
    if (!user) return;

    setLoading(true);
    try {
      setContacts(await ChatService.listContacts());
    } catch (error) {
      console.error("Failed to fetch contacts:", error);
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchContacts();
    }
  }, [user]);

  return {
    contacts,
    loading,
    refetch: fetchContacts,
  };
}
